import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSwipeable } from 'react-swipeable';
import axios from 'axios';
import { CommentSection } from 'react-comments-section'; // Snippet import
// import 'react-comments-section/dist/index.css'; // Snippet import CSS
import './Comment.css'; // Snippet import CSS
import "../CommentSection/Styles/App.scss";
import Comment from "../CommentSection/Comment";
import AddComment from "../CommentSection/AddComment";

import Hls from "hls.js";
import P2pEngine from 'cdnbye';
const config = require('../../config');

const IconHome = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? "white" : "none"} stroke="white" strokeWidth={active ? "0" : "2.5"} strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
);

const IconFriends = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={active ? "2.8" : "2.5"} strokeLinecap="round" strokeLinejoin="round" style={{ opacity: active ? 1 : 0.6 }}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
);

const IconPlus = () => (
  <div className="plus-btn">
    <div className="plus-bg-left"></div>
    <div className="plus-bg-right"></div>
    <div className="plus-icon">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="black" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
    </div>
  </div>
);

const IconInbox = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={active ? "2.8" : "2.5"} strokeLinecap="round" strokeLinejoin="round" style={{ opacity: active ? 1 : 0.6 }}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
);

const IconProfile = ({ active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={active ? "2.8" : "2.5"} strokeLinecap="round" strokeLinejoin="round" style={{ opacity: active ? 1 : 0.6 }}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
);

const IconHeart = ({ filled }) => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill={filled ? "#fe2c55" : "white"} stroke={filled ? "none" : "white"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))' }}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
);

const IconComment = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))' }}><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
);

const IconBookmark = ({ filled }) => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill={filled ? "#ffce00" : "white"} stroke={filled ? "none" : "white"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))' }}><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
);

const IconShare = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))' }}><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
);

const IconMusic = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>
);

const IconClose = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.5))' }}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);

const IconSend = ({ fill = "#fe2c55", width = "20", height = "20" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
);

const IconSearch = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.8, visibility: "hidden", }}><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
);

const IconLive = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.8 }}><path d="M23 7l-7 5 7 5V7z"></path><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
);

const PURE_CSS = `
    * { box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
    
    /* Scoped to popup-container context roughly */

    /* Video Layer */
    .video-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
    .video-bg {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .video-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40%;
        background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
        pointer-events: none;
        z-index: 2;
    }

    /* Top Nav */
    .top-nav {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        // padding: 40px 16px 10px;
        padding: 20px 16px 10px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 10;
        background: linear-gradient(to bottom, rgba(0,0,0,0.4), transparent);
        pointer-events: none;
    }
    .top-nav > * { pointer-events: auto; }

    .top-center {
        display: flex;
        gap: 16px;
        font-weight: 600;
        font-size: 16px;
        color: rgba(255,255,255,0.6);
    }
    .top-center span.active {
        color: white;
        position: relative;
    }
    .top-center span.active::after {
        content: '';
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 3px;
        background: white;
        border-radius: 2px;
    }

    /* Right Sidebar Actions */
    .right-sidebar {
        position: absolute;
        right: 10px;
        // bottom: 120px; 
        /* Lowered from 15vh (approx 130-150px) to be less "high up" */
        bottom: 20px; 


        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px; /* Reduced gap from 20px */
        z-index: 10;
        pointer-events: auto; /* ENABLE CLICKS */
        transform: scale(0.9); /* Scale down the whole column */
        transform-origin: bottom right;
    }
    .action-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        transition: transform 0.1s;
    }
    .action-btn:active { transform: scale(0.85); }
    .action-text {
        color: white;
        font-size: 11px; /* Slightly smaller text */
        font-weight: 600;
        margin-top: 4px;
        text-shadow: 0 1px 2px rgba(0,0,0,0.5);
    }
    
    /* Avatar specific styles */
    .avatar-container {
        position: relative;
        margin-bottom: 8px;
    }
    .avatar-img {
        width: 45px; /* Slightly smaller avatar */
        height: 45px;
        border-radius: 50%;
        border: 1px solid white;
        object-fit: cover;
    }
    .plus-badge {
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 18px;
        height: 18px;
        background: #fe2c55;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 14px;
        font-weight: bold;
    }

    /* Album Disc Animation */
    .disc-container {
        margin-top: 5px;
        width: 45px; /* Smaller disc */
        height: 45px;
        background: #222;
        border-radius: 50%;
        border: 8px solid #111;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        animation: spin 5s linear infinite;
        background-size: cover;
    }
    .disc-note {
        position: absolute;
        right: 0;
        bottom: 0;
        opacity: 0;
        animation: floatNote 2s linear infinite;
    }
    @keyframes spin { 100% { transform: rotate(360deg); } }
    @keyframes floatNote { 
        0% { opacity: 0; transform: translate(0, 0) rotate(0deg); }
        50% { opacity: 1; }
        100% { opacity: 0; transform: translate(-20px, -40px) rotate(-20deg); }
    }

    /* Bottom Info Area */
    .bottom-info {
        position: absolute;
        // bottom: 20px;
        bottom: 10px;

        left: 0;
        width: 75%;
        padding: 16px;
        z-index: 10;
        color: white;
        text-align: left;
        pointer-events: none;
    }
    .bottom-info > * { pointer-events: auto; }

    .username {
        font-weight: 700;
        font-size: 17px;
        margin-bottom: 6px;
        text-shadow: 0 1px 2px rgba(0,0,0,0.5);
        cursor: pointer;
    }
    .description {
        font-size: 15px;
        line-height: 1.3;
        margin-bottom: 10px;
        text-shadow: 0 1px 1px rgba(0,0,0,0.5);
    }
    .hashtags { font-weight: 700; }
    
    .music-ticker {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        gap: 8px;
    }
    .ticker-text {
        width: 150px;
        white-space: nowrap;
        overflow: hidden;
    }
    .ticker-content {
        display: inline-block;
        animation: marquee 5s linear infinite;
    }
    @keyframes marquee { 0% { transform: translateX(100%); } 100% { transform: translateX(-100%); } }

    /* Custom Plus Button */
    .plus-btn {
        position: relative;
        width: 45px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .plus-bg-left, .plus-bg-right {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
    .plus-bg-left { background: #65D2E9; left: -3px; z-index: 1; }
    .plus-bg-right { background: #E6436D; right: -3px; z-index: 1; }
    .plus-icon {
        position: relative;
        width: 100%;
        height: 100%;
        background: white;
        z-index: 2;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    /* Comment Drawer */
    .drawer-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 30;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s;
    }
    .drawer-overlay.open { opacity: 1; pointer-events: auto; }

    .comment-drawer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 70%;
        background: #f8f8f8; 
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        z-index: 40;
        transform: translateY(100%);
        transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
        display: flex;
        flex-direction: column;
        padding-bottom: env(safe-area-inset-bottom);
    }
    .comment-drawer.open { transform: translateY(0); }

    .drawer-header {
        height: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding-top: 8px;
        position: relative;
        font-weight: 700;
        font-size: 14px;
        color: #161823;
        border-bottom: 1px solid rgba(0,0,0,0.05);
    }
    .drawer-handle {
        width: 40px;
        height: 4px;
        background: #cfcfcf;
        border-radius: 2px;
        margin-bottom: 8px;
    }
    .drawer-title {
        font-size: 13px;
        font-weight: 700;
    }
    .close-btn { display: none; }

    .comment-list {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        background: white;
    }
    
    .comment-input-area {
        height: 60px;
        border-top: 1px solid rgba(0,0,0,0.05);
        background: white;
        display: flex;
        align-items: center;
        padding: 8px 16px;
        gap: 12px;
    }
    
    /* Dots */
    .dots-container {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 8px;
        z-index: 3;
    }
    .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.4);
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }
    .active-dot { background-color: white; }
    
     /* Close Button Custom */
    .custom-close-btn {
        position: absolute;
        // top: 40px;
        top: 20px;

        right: 16px;
        z-index: 50;
        cursor: pointer;
        pointer-events: auto; /* ENABLE CLICKS */
    }

    /* --- OVERRIDES FOR IMPORTED COMMENT COMPONENTS --- */
    
    /* Fix Comment Item Layout */
    .comment-drawer .comment {
        background: transparent !important;
        padding: 0 !important;
        margin-bottom: 12px !important;
        gap: 10px !important;
        align-items: flex-start !important;
    }
    
    .comment-drawer .comment--body {
        margin-top: 0 !important;
    }

    /* Header: Avatar + Name + Time */
    .comment-drawer .comment--header {
        justify-content: flex-start !important;
        position: relative !important;
        margin-bottom: 2px !important;
    }

    .comment-drawer .profile-pic {
        width: 32px !important;
        height: 32px !important;
        margin-right: 12px !important;
        background-color: #eee;
    }

    .comment-drawer .username {
        color: #161823 !important; /* Darker, not light grey */
        font-size: 13px !important;
        margin-top: 0 !important;
        font-weight: 600 !important;
    }

    .comment-drawer .comment-posted-time {
        font-size: 12px !important;
        color: rgba(22, 24, 35, 0.5) !important;
        margin-left: 8px !important;
        margin-top: 0 !important;
    }

    /* Content Alignment */
    .comment-drawer .comment-content {
        margin-left: 44px !important; /* Align with text start (32px avatar + 12px gap) */
        margin-top: 0 !important;
        font-size: 14px !important;
        color: #161823 !important;
        font-weight: 400 !important;
        line-height: 1.4 !important;
    }

    /* Buttons (Reply/Like) */
    .comment-drawer .comment--btn {
        margin-left: 44px !important;
        margin-top: 4px !important;
    }
    .comment-drawer .comment--btn button {
        color: rgba(22, 24, 35, 0.5) !important;
        font-size: 12px !important;
        padding: 0 !important; 
        font-weight: 600 !important;
    }
    .comment-drawer .comment--btn button svg {
        fill: rgba(22, 24, 35, 0.5) !important;
    }

    /* Hide unnecessary elements from the imported component if needed */
    .comment-drawer .you-tag { display: none !important; }

    /* Override AddComment Component Styles */
    .comment-drawer .add-comment {
        position: relative !important;
        bottom: auto !important;
        left: auto !important;
        width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
    }

    /* The input container usually has a profile pic we might want to hide or style */
    .comment-drawer .add-comment .profile-pic {
        display: none !important; /* Hide input avatar to match TikTok clean style or keep it if desired */
    }

    .comment-drawer .add-comment textarea {
        background: #F1F1F2 !important;
        border: none !important;
        border-radius: 99px !important; /* Pill shape */
        padding: 10px 16px !important;
        height: 40px !important;
        min-height: 40px !important;
        color: #161823 !important;
        line-height: 20px !important;
        font-size: 14px !important;
        resize: none !important;
        overflow: hidden !important;
    }
    .comment-drawer .add-comment textarea:focus {
        outline: none !important;
        background: #e5e5e5 !important;
    }

    .comment-drawer .add-comment .send-btn-container {
        display: flex !important;
        align-items: center !important;
    }

    .comment-drawer .add-comment .add-btn {
        background: transparent !important;
        color: #fe2c55 !important;
        padding: 0 10px !important;
        font-size: 14px !important;
        font-weight: 600 !important;
    }
`;



// --- Styles (adapted to resemble Reel.js look) ---
const styles = {
  reelContainer: {
    top: '0px',
    width: '100%',
    height: '100%',
    backgroundColor: '#111', // dark background similar to Reel
    margin: '0',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '0',
    display: 'flex',
    flexDirection: 'column',
  },
  reelContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1,
  },
  overlay: {
    position: 'absolute',
    top: '-0px',
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
    display: 'flex',
    pointerEvents: 'none',
  },
  topNav: {
    position: 'absolute',
    top: '15px',
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    color: 'rgba(255, 255, 255, 0.7)',
    fontWeight: 'bold',
    fontSize: '16px',
    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    pointerEvents: 'auto',
    zIndex: 5,
  },
  sidebar: {
    position: 'absolute',
    bottom: '15px',
    right: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    pointerEvents: 'auto',
  },
  bottomInfo: {
    position: 'absolute',
    bottom: '15px',
    left: '15px',
    right: '80px',
    color: 'white',
    textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
    pointerEvents: 'auto',
  },
  username: {
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },
  caption: {
    fontSize: '14px',
    marginBottom: '10px',
    lineHeight: '1.3',
    maxHeight: '6em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  soundInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    zIndex: 20,
    background: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '35px',
    height: '35px',
    fontSize: '24px',
    lineHeight: '40px',
    textAlign: 'center',
    cursor: 'pointer',
    pointerEvents: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  commentSectionContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '65%',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    zIndex: 15,
    overflowY: 'hidden',
    borderTop: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px -2px 10px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease-out',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  commentSectionHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
    borderBottom: '1px solid #f0f0f0',
    backgroundColor: '#f9f9f9',
    minHeight: '25px',
    position: 'relative',
    cursor: 'grab',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  commentDragIcon: {
    width: '50px',
    height: '6px',
    backgroundColor: '#cccccc',
    borderRadius: '5px',
  },
  commentSectionContent: {
    flexGrow: 1,
    overflowY: 'auto',
    paddingBottom: '100px',
    overflowX: 'hidden',
  },
  addCommentContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: '#fff',
    padding: '10px',
    borderTop: '1px solid #e0e0e0',
    zIndex: 1000,
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.5)',
  },
  activeDot: {
    backgroundColor: 'white',
  },
  dotsContainer: {
    position: 'absolute',
    bottom: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    zIndex: 3,
  },
  commentLikeButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    color: '#666',
  },
};

// --- Main Popup Component (full functionality from Popup_v3) ---
const PopupV4 = ({ property, setShowPopup, goToPreviousMarker, goToNextMarker, currentMarkerIndex }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(true);
  const audioRef = useRef(null);
  const videoRef = useRef(null);

  const cleanupAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.removeAttribute('src');
      audioRef.current.load();
      audioRef.current = null;
      setIsAudioPlaying(false);
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      cleanupAudio();
    }
  }, [currentMarkerIndex]);

  useEffect(() => {
    const preventTouchmove = (e) => {
      e.preventDefault();
    };
    if (isPopupOpen) {
      document.addEventListener('touchmove', preventTouchmove, { passive: false });
    }
    return () => {
      document.removeEventListener('touchmove', preventTouchmove);
    };
  }, [isPopupOpen]);

  const [comments, updateComments] = useState([]);
  const [deleteModalState, setDeleteModalState] = useState(false);

  const commentData = {
    currentUser: { username: "juliusomo" },
    comments: [
      {
        id: 1,
        content: "Impressive! Though it seems the drag feature could be improved...",
        createdAt: "23 November 2021",
        score: 12,
        username: "amyrobson",
        currentUser: false,
        replies: []
      },
      {
        id: 2,
        content: "Woah, your project looks awesome! How long have you been coding for?",
        createdAt: "5 December 2021",
        score: 5,
        username: "maxblagun",
        currentUser: false,
        replies: [
          {
            id: 3,
            content: "@maxblagun, If you're still new, I'd recommend focusing on the fundamentals...",
            createdAt: "18 December 2021",
            score: 4,
            username: "ramsesmiron",
            currentUser: false,
            replies: []
          },
          {
            id: 4,
            content: "@ramsesmiron, I couldn't agree more with this...",
            createdAt: "30 December 2021",
            username: "juliusomo",
            currentUser: true,
            replies: []
          }
        ]
      }
    ]
  };

  const getData = async () => {
    updateComments(commentData.comments);
  };

  useEffect(() => {
    localStorage.getItem("comments") !== null
      ? updateComments(JSON.parse(localStorage.getItem("comments")))
      : getData();
  }, []);

  useEffect(() => {
    localStorage.setItem("comments", JSON.stringify(comments));
    deleteModalState
      ? document.body.classList.add("overflow--hidden")
      : document.body.classList.remove("overflow--hidden");
  }, [comments, deleteModalState]);

  let updateScore = (score, id, type) => {
    let updatedComments = [...comments];
    if (type === "comment") {
      updatedComments.forEach((data) => {
        if (data.id === id) {
          data.score = score;
        }
      });
    } else if (type === "reply") {
      updatedComments.forEach((comment) => {
        comment.replies.forEach((data) => {
          if (data.id === id) {
            data.score = score;
          }
        });
      });
    }
    updateComments(updatedComments);
  };

  let updateReplies = (replies, id) => {
    let updatedComments = [...comments];
    updatedComments.forEach((data) => {
      if (data.id === id) {
        data.replies = [...replies];
      }
    });
    updateComments(updatedComments);
  };

  let editComment = (content, id, type) => {
    let updatedComments = [...comments];
    if (type === "comment") {
      updatedComments.forEach((data) => {
        if (data.id === id) {
          data.content = content;
        }
      });
    } else if (type === "reply") {
      updatedComments.forEach((comment) => {
        comment.replies.forEach((data) => {
          if (data.id === id) {
            data.content = content;
          }
        });
      });
    }
    updateComments(updatedComments);
  };

  let commentDelete = (id, type, parentComment) => {
    let updatedComments = [...comments];
    let updatedReplies = [];
    if (type === "comment") {
      updatedComments = updatedComments.filter((data) => data.id !== id);
    } else if (type === "reply") {
      comments.forEach((comment) => {
        if (comment.id === parentComment) {
          updatedReplies = comment.replies.filter((data) => data.id !== id);
          comment.replies = updatedReplies;
        }
      });
    }
    updateComments(updatedComments);
  };

  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [likeCount, setLikeCount] = useState(property.likeCount || 0);
  const [commentPanelVisible, setCommentPanelVisible] = useState(false);
  const [rawComments, setRawComments] = useState([]);
  const transformCommentsForSection = (apiComments) => {
    if (!Array.isArray(apiComments)) return [];
    const commentMap = {};
    const topLevelComments = [];

    apiComments.forEach(comment => {
      const authorName = comment.author?.username || 'Anonymous';
      commentMap[comment._id] = {
        userId: comment.author?._id || 'unknownUserId',
        comId: comment._id,
        fullName: authorName,
        avatarUrl: comment.author?.profilePicture || `https://ui-avatars.com/api/?name=${encodeURIComponent(authorName)}&background=random&color=fff`,
        text: comment.content,
        timestamp: comment.createdAt ? new Date(comment.createdAt).toISOString() : new Date().toISOString(),
        replies: [],
        likeCount: comment.likeCount || 0,
        onLike: () => handleCommentLike(comment._id),
        commentId: comment._id,
        createdAt: comment.createdAt,
        content: comment.content,
        username: authorName,
        score: comment.likeCount || 0,
      };
    });

    apiComments.forEach(comment => {
      if (comment.parentComment && commentMap[comment.parentComment._id]) {
        commentMap[comment.parentComment._id].replies.push(commentMap[comment._id]);
      } else if (comment.parentComment && commentMap[comment.parentComment]) {
        commentMap[comment.parentComment].replies.push(commentMap[comment._id]);
      } else if (!comment.parentComment) {
        topLevelComments.push(commentMap[comment._id]);
      }
    });
    return topLevelComments;
  };

  const commentDataForSection = useMemo(() => transformCommentsForSection(rawComments), [rawComments]);
  const [commentLikes, setCommentLikes] = useState({});


  const API_ENDPOINT = config.getAllURL + 'api/comment';




  /* New State for Like Status */
  const [isLiked, setIsLiked] = useState(false);

  /* Fetch Initial Like Status & Count */
  useEffect(() => {
    const checkLikeStatus = async () => {
      if (!property._id) return;
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const API_CHECK_LIKE_ENDPOINT = config.getAllURL + 'api/like/checkLike';
          const response = await axios.post(API_CHECK_LIKE_ENDPOINT, { mapMarker: property._id }, { headers: { Authorization: `Bearer ${token}` } });
          setIsLiked(response.data.liked);
          // Fix for stale like count on reopen: 
          // If backend provides the latest count, update it.
          if (response.data.likeCount !== undefined) {
            setLikeCount(response.data.likeCount);
          }
        }
      } catch (error) {
        console.error('Error checking like status:', error);
      }
    };
    checkLikeStatus();
  }, [property._id]);

  const handleCommentLike = async (commentId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You must be logged in to like this comment.');
        loginAction.onLogin();
        return;
      }
      const API_LIKE_COMMENT_ENDPOINT = config.getAllURL + 'api/comment/like';
      await axios.post(API_LIKE_COMMENT_ENDPOINT, { commentId }, { headers: { Authorization: `Bearer ${token}` } });
      setCommentLikes(prev => ({ ...prev, [commentId]: (prev[commentId] || 0) + 1 }));
    } catch (error) {
      console.error('Error liking comment:', error.response ? error.response.data : error.message);
      alert('Failed to like comment. Please try again.');
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleNextMedia(),
    onSwipedRight: () => handlePrevMedia(),
    onMouseUp: () => goToNextMarker(),
    onMouseDown: () => goToPreviousMarker(),
    onSwipedUp: () => goToNextMarker(),
    onSwipedDown: (e) => {
      e.event.preventDefault();
      goToPreviousMarker();
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  /* Swipe Handler for Comment Drawer Header (Drag down to close) */
  const commentDrawerSwipeHandlers = useSwipeable({
    onSwipedDown: (e) => {
      e.event.stopPropagation();
      setCommentPanelVisible(false);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const currentUserData = useMemo(() => ({
    currentUserId: 'PLEASE_REPLACE_USER_ID',
    currentUserImg: `https://ui-avatars.com/api/name=User&background=random&color=fff`,
    currentUserProfile: '#',
    currentUserFullName: 'Current User Name'
  }), []);

  const isUnmounting = useRef(false);
  useEffect(() => {
    return () => {
      isUnmounting.current = true;
    };
  }, []);

  useEffect(() => {
    const fetchComments = async () => {
      if (!property._id) return;
      try {
        const response = await axios.get(`${API_ENDPOINT}?mapMarker=${property._id}`);
        setRawComments(response.data || []);
      } catch (error) {
        console.error('Error fetching comments:', error);
        setRawComments([]);
      }
    };
    fetchComments();
  }, [commentPanelVisible, property._id, API_ENDPOINT]);

  useEffect(() => {
    const currentMedia = property.media?.[currentMediaIndex];
    const soundtrackUrl = 'https://' + property.soundtrackUrl;
    const isImage = currentMedia && (currentMedia.type === 'image' || /\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url));
    if (soundtrackUrl && soundtrackUrl.trim() !== '' && isImage) {
      if (!audioRef.current) {
        audioRef.current = new Audio(soundtrackUrl);
        audioRef.current.loop = true;
        audioRef.current.volume = 0.5;
        audioRef.current.onplaying = () => setIsAudioPlaying(true);
        audioRef.current.onpause = () => setIsAudioPlaying(false);
        audioRef.current.onerror = (e) => {
          console.error('Audio playback error:', e);
          setIsAudioPlaying(false);
        };
        audioRef.current.play().catch(error => {
          console.error('Audio play failed:', error);
        });
      }
    } else {
      cleanupAudio();
    }
    return () => {
      if (isUnmounting.current) {
        cleanupAudio();
      } else {
        if (!isImage) {
          cleanupAudio();
        }
      }
    };
  }, [property.soundtrackUrl, currentMediaIndex]);

  const hlsRef = useRef(null);

  useEffect(() => {
    const currentMedia = property.media?.[currentMediaIndex];
    if (!currentMedia || !currentMedia.url) return;

    if (currentMedia.type === 'video' && !/\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url)) {
      const url = `https://${currentMedia.url}`;

      if (url.endsWith('.m3u8') && Hls.isSupported()) {
        if (hlsRef.current) {
          hlsRef.current.destroy();
        }

        const p2pConfig = {
          logLevel: 'debug',
          live: false,        // set to true in live mode
          // getStats: function(totalP2PDownloaded, totalP2PUploaded, totalHTTPDownloaded) {
          //     console.log(`totalP2PDownloaded: ${totalP2PDownloaded} totalP2PUploaded: ${totalP2PUploaded} totalHTTPDownloaded: ${totalHTTPDownloaded}`);
          // }
        };

        if (P2pEngine.isSupported()) {
          new P2pEngine(Hls, p2pConfig);
        }

        const hls = new Hls({
          maxBufferSize: 0,
          maxBufferLength: 30,
          liveSyncDurationCount: 10,
        });

        hlsRef.current = hls;
        hls.loadSource(url);
        hls.attachMedia(videoRef.current);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoRef.current.play().catch(e => console.log("Auto-play prevented", e));
        });

      } else {
        // MP4/Normal playback (Service Worker handles P2P if setup)
        if (videoRef.current) {
          videoRef.current.src = url;
          videoRef.current.load(); // Important for switching sources
        }
      }
    }

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
    }
  }, [currentMediaIndex, property.media]);


  const handleSubmitComment = async (data) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You must be logged in to comment.');
        loginAction.onLogin();
        return;
      }
      const payload = {
        content: data.text,
        mapMarker: property._id,
      };
      if (data.parentId) {
        payload.parentComment = data.parentId;
      }
      await axios.post(API_ENDPOINT, payload, { headers: { Authorization: `Bearer ${token}` } });
      const response = await axios.get(`${API_ENDPOINT}?mapMarker=${property._id}`);
      setRawComments(response.data || []);
      if (property.onCommentAdded) {
        property.onCommentAdded((response.data || []).length);
      }
    } catch (error) {
      console.error('Error posting comment:', error.response ? error.response.data : error.message);
      alert('Failed to post comment. Please try again.');
    }
  };

  const loginAction = useMemo(() => ({
    onLogin: () => {
      alert('Login to comment. Please implement your login redirection.');
    },
    signUpLink: '/signup'
  }), []);

  const handleLike = async () => {
    // Optimistic Update
    const newLikedState = !isLiked;
    setIsLiked(newLikedState);
    setLikeCount(prev => newLikedState ? prev + 1 : prev - 1);

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You must be logged in to like this post.');
        loginAction.onLogin();
        // Rollback
        setIsLiked(!newLikedState);
        setLikeCount(prev => !newLikedState ? prev + 1 : prev - 1);
        return;
      }
      const API_LIKE_ENDPOINT = config.getAllURL + 'api/like';
      await axios.post(API_LIKE_ENDPOINT, { mapMarker: property._id, liked: newLikedState }, { headers: { Authorization: `Bearer ${token}` } });
    } catch (error) {
      console.error('Error liking post:', error.response ? error.response.data : error.message);
      // Rollback on error
      setIsLiked(!newLikedState);
      setLikeCount(prev => !newLikedState ? prev + 1 : prev - 1);
      alert('Failed to like post. Please try again.');
    }
  };

  const handleCommentIconClick = () => setCommentPanelVisible(!commentPanelVisible);
  const handleSave = () => alert('Save functionality is not implemented yet.');
  const handleShare = () => alert('Share functionality is not implemented yet.');

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        if (commentPanelVisible) setCommentPanelVisible(false);
        else setShowPopup(false);
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [setShowPopup, commentPanelVisible]);

  const currentMedia = property.media?.[currentMediaIndex];

  const handleSwipe = (e) => {
    if (commentPanelVisible) return;
    if (e.event.target.tagName === 'BUTTON' || e.event.target.closest('[data-element="comment-section-container"]')) return;
    if (property.media && property.media.length > 1) {
      if (e.dir === 'Left') handleNextMedia();
      else if (e.dir === 'Right') handlePrevMedia();
    }
  };

  const [startTouchY, setStartTouchY] = useState(null);
  const handleTouchStart = (e) => setStartTouchY(e.touches[0].clientY);
  const handleTouchMove = (e) => {
    if (startTouchY === null) return;
    const touchMove = e.touches[0].clientY;
    if (touchMove > startTouchY + 10) {
      setCommentPanelVisible(false);
    }
  };
  const handleTouchEnd = () => setStartTouchY(null);

  const handleNextMedia = (e) => {
    e?.stopPropagation();
    if (property.media && property.media.length > 0) {
      setCurrentMediaIndex(prev => (prev + 1) % property.media.length);
    }
  };
  const handlePrevMedia = (e) => {
    e?.stopPropagation();
    if (property.media && property.media.length > 0) {
      setCurrentMediaIndex(prev => (prev === 0 ? property.media.length - 1 : prev - 1));
    }
  };

  const timeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    if (diffInSeconds < 2) return 'just now';
    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) return `${diffInDays}d ago`;
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) return `${Math.floor(diffInDays / 30)}mo ago`;
    return `${Math.floor(diffInMonths / 12)}y ago`;
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#333', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999999 }} onClick={() => {
      if (commentPanelVisible) setCommentPanelVisible(false);
      else setShowPopup(false);
    }}>
      <div style={styles.reelContainer} onClick={(e) => { e.stopPropagation(); }}>
        <style>{PURE_CSS}</style>
        <div className="custom-close-btn" onClick={() => setShowPopup(false)}>
          <IconClose />
        </div>

        <div {...swipeHandlers} style={{ width: '100%', height: '100%', position: 'relative', overflow: 'hidden', touchAction: 'pan-y' }}>
          {currentMedia?.url && (
            <div>
              {currentMedia.type === 'video' && !/\\.(png|jpe?g|gif|webp)$/i.test(currentMedia.url) ? (
                <div style={{ position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <video
                    key={currentMedia.url}
                    // src={`https://${currentMedia.url}`} // Remove src prop here, handled in useEffect/ref
                    poster={property.thumbnailUrl || ''}
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                    autoPlay
                    loop
                    playsInline
                    muted={false}
                    ref={videoRef}
                    onCanPlayThrough={() => {
                      if (audioRef.current && !isAudioPlaying && property.soundtrackUrl && property.soundtrackUrl.trim() !== '') {
                        audioRef.current.loop = false;
                        audioRef.current.play().catch(() => { });
                      }
                    }}
                    onPlay={() => {
                      if (audioRef.current && !isAudioPlaying && property.soundtrackUrl && property.soundtrackUrl.trim() !== '') {
                        audioRef.current.play().catch(() => { });
                      }
                    }}
                    onPause={() => {
                      if (audioRef.current) audioRef.current.pause();
                    }}
                    onEnded={() => {
                      if (audioRef.current) audioRef.current.pause();
                    }}
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <div style={{ position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img
                    key={currentMedia.url}
                    src={`https://${currentMedia.url}`}
                    alt={property.title || 'Property image'}
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    onError={(e) => console.error('Image failed to load:', currentMedia.url, e)}
                  />
                </div>
              )}
              <div style={styles.dotsContainer}>
                {property.media.map((_, index) => (
                  <div key={index} style={{ ...styles.dot, ...(index === currentMediaIndex ? styles.activeDot : {}) }}></div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div style={styles.overlay}>
          <div className="top-nav">
            <IconLive />
            <div className="top-center">
              <span>Following</span>
              <span className="active">For You</span>
            </div>
            <IconSearch />
          </div>

          <div className="bottom-info">
            <div className="username">
              @{property.author?.username || 'user'}
            </div>
            <div className="description">
              {property.description} <span className="hashtags">#travel</span>
            </div>
            <div className="music-ticker">
              <IconMusic />
              <div className="ticker-text">
                <div className="ticker-content">Original Sound - {property.author?.username || 'Artist'}</div>
              </div>
            </div>
          </div>

          <div className="right-sidebar">
            <div className="action-btn avatar-container">
              <img src={property.userProfileImage || 'https://ui-avatars.com/api/?name=P&background=random&color=fff'} alt="User profile"
                className="avatar-img" />
              <div className="plus-badge">+</div>
            </div>

            {/* Like */}
            <div className="action-btn" onClick={(e) => { e.stopPropagation(); handleLike(); }}>
              <IconHeart filled={isLiked} />
              <span className="action-text">{likeCount}</span>
            </div>

            {/* Comment */}
            <div className="action-btn" onClick={(e) => { e.stopPropagation(); setCommentPanelVisible(true); }}>
              <IconComment />
              <span className="action-text">{commentDataForSection?.length || property.commentCount || 0}</span>
            </div>

            {/* Save */}
            <div className="action-btn" onClick={(e) => { e.stopPropagation(); handleSave(); }}>
              <IconBookmark filled={false} />
              <span className="action-text">{property.saveCount || 'Save'}</span>
            </div>

            {/* Share */}
            <div className="action-btn" onClick={(e) => { e.stopPropagation(); handleShare(); }}>
              <IconShare />
              <span className="action-text">Share</span>
            </div>

            {/* Disc */}
            <div className="disc-container" style={{ backgroundImage: `url(${property.soundImageUrl || 'https://via.placeholder.com/50'})` }}>
              <div className="disc-note">
                <IconMusic />
              </div>
            </div>
          </div>
        </div>

        {/* Comment Drawer Overlay + Slider */}
        <div className={`drawer-overlay ${commentPanelVisible ? 'open' : ''}`} onClick={() => setCommentPanelVisible(false)}></div>

        <div className={`comment-drawer ${commentPanelVisible ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
          <div className="drawer-header" {...commentDrawerSwipeHandlers} onClick={() => setCommentPanelVisible(false)}>
            <div className="drawer-handle"></div>
            <div className="drawer-title">{commentDataForSection.length} comments</div>
          </div>

          <div className="comment-list">
            {commentDataForSection.map((comment) => (
              <Comment
                key={comment.comId}
                commentData={comment}
                updateScore={updateScore}
                updateReplies={updateReplies}
                editComment={editComment}
                commentDelete={commentDelete}
                setDeleteModalState={setDeleteModalState}
              />
            ))}
          </div>

          <div className="comment-input-area">
            <div style={{ width: '100%' }}>
              <AddComment buttonValue={<IconSend fill="#666" width="24" height="24" />} onSubmit={handleSubmitComment} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupV4;
